<template>
  <div>
    <span v-if="row.order">{{ row.order.trade_state }}</span>
    <span v-else-if="row.ccr_order">{{ row.ccr_order.status }}</span>
  </div>
</template>

<script>
export default {
  name: 'OrderStatus',
  components: { },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/coupon_codes/common/OrderStatus.vue